// extracted by mini-css-extract-plugin
module.exports = {"safe":"src-components-root-styles__safe--ZIbBH","safeTop":"src-components-root-styles__safeTop--AFqak"};